import { render, staticRenderFns } from "./BeanSelect.vue?vue&type=template&id=496badba"
import script from "./BeanSelect.vue?vue&type=script&lang=js"
export * from "./BeanSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports